import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import { Button } from "reactstrap"
import "react-multi-date-picker/styles/backgrounds/bg-dark.css"


export default class Invoices extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'invoice',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: '',
            ids: [],
            filters: {
                comId: 0,
                type: -1,
                fasl: 0,
                startDate: null,
                startDateM: null,
                endDate: null,
                endDateM: null,
                taxId: null,
                inty: 0,
                statusTax: 0,
                serial: 0,
                sort: null,
                typeSort: null
            }
        };
    }
    Sort(name) {
        this.state.filters.sort = name;
        if (this.state.filters.typeSort != null) {
            if (this.state.filters.typeSort == 0)
                this.state.filters.typeSort = 1;
            else
                this.state.filters.typeSort = 0;
        }
        else
            this.state.filters.typeSort = 0;
            
        this.refreshData();
    }
    setTypeRec(v) {
        this.state.filters.type = v;
        this.setState({ data: this.state.data });
    }
    setinty(v) {
        this.state.filters.inty = v;
        this.setState({ data: this.state.data });
    }
    setStatusTax(v) {
        this.state.filters.statusTax = v;
        this.setState({ data: this.state.data });
    }
    setTypeFasl(v) {
        this.state.filters.fasl = v;
        this.setState({ data: this.state.data });
    }
    setStartDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.startDate = data;
            this.state.filters.startDateM = v.toDate();
        }
        else {
            this.state.filters.startDate = null;
            this.state.filters.startDateM = null;
        }

        this.setState({ data: this.state.data });
    }
    setEndDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.endDate = data;
            this.state.filters.endDateM = v.toDate();
        }
        else {
            this.state.filters.endDate = null;
            this.state.filters.endDateM = null;
        }

        this.setState({ data: this.state.data });
    }


    recoveryData(e) {
        this.state.phrase = "";
        this.state.filters.comId = 0;
        this.state.filters.fasl = 0;
        this.state.filters.type = -1;
        this.state.filters.startDateM = null;
        this.state.filters.startDate = null;
        this.state.filters.endDateM = null;
        this.state.filters.endDate = null;
        this.state.filters.inty = 0;
        this.state.filters.taxId = null;
        this.state.filters.statusTax = 0;
        this.state.filters.serial = 0;
        this.refreshData(e);
    }

    componentDidMount() {
        this.refreshData();
    }
    enqueue(id) {
        this.sendEnqueue([id]);
    }
    sendEnqueue(ids) {
        this.httpPost("api/v1/invoice/enqueue", {
            ids: ids,
            companyId: this.state.data.global.company.id,

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ارسال با موفقیت انجام پذیرفت گردید");
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    sendEnqueueAll(ids) {
        this.httpPost("api/v1/invoice/enqueueall", {
            companyId: this.state.data.global.company.id,

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ارسال با موفقیت انجام پذیرفت گردید");
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    reference(id) {
        this.httpPost("api/v1/invoice/reference", {
            id: id,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("استعلام صورتحساب دریافت شد");
                    this.setState({
                        redirect: "/invoice/edit/" + id
                    })
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    loadPersonsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getcustomer/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.fullName
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    referenceAll() {
        this.httpPost("api/v1/invoice/referenceall", {
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("استعلام صورتحساب دریافت شد");
                    this.setState({
                        redirect: "/invoices/"
                    })
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getToolBars(record) {
        var m = [];
        m.push(<li><NavLink to={"/invoice/view/" + record.id} title="مشاهده"><em className="icon ni ni-eye"></em> <span>مشاهده</span></NavLink></li>);
        if (record.status === 1 || record.status === 3 || record.sendToTax) {
            m.push(<li><NavLink to={"/invoice/edit/" + record.id} title="ویرایش"><em className="icon ni ni-pen"></em> <span>ویرایش</span></NavLink></li>);
            m.push(<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف"><em className="icon ni ni-na"></em> <span>حذف صورتحساب</span></a></li>);
        }
        if (record.status === 1 || record.status === 3) {
            m.push(<li><a className="hand" onClick={e => this.enqueue(record.id)} title="ارسال به سامانه"><em class="icon ni ni-send"></em> <span>ارسال به سامانه</span></a></li>);
        }
        if (record.status === 2) {
            m.push(<li><a className="hand" onClick={e => this.reference(record.id)} title="استعلام"><em class="icon ni ni-search"></em> <span>استعلام صورتحساب</span></a></li>);
        }
        if (record.status === 4) {
            m.push(<li><NavLink to={"/invoice/cancell/" + record.id} title="صدور ابطالی"><em class="icon ni ni-property-remove"></em> <span>صدور ابطالی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/modify/" + record.id} title="صدور اصلاحی"><em class="icon ni ni-property-add"></em> <span>صدور اصلاحی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/return/" + record.id} title="صدور برگشت از فروش"><em class="icon ni ni-property-alt"></em> <span>صدور برگشت از فروش</span></NavLink></li>);
        }
        return m;
    }
    setChecked(e, id) {
        var t = [];
        this.state.ids.forEach(i => {
            if (i != id) t.push(i);
        });
        if (e.target.checked) t.push(id);
        this.state.ids = t;
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست صورتحسابهای فروش</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} صورتحساب ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {/*<li>*/}
                                        {/*    <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF اطلاعات</span></a>*/}
                                        {/*</li>*/}
                                        <li>
                                            <a className="btn btn-info" onClick={e => this.referenceAll()}><em class="icon ni ni-arrow-up"></em><span>بررسی صورت وضعیت فاکتور های ارسالی</span></a>
                                        </li>
                                        <li>
                                            <a className="btn btn-warning" onClick={e => this.sendEnqueueAll(this.state.ids)}><em class="icon ni ni-arrow-up"></em><span>ارسال فاکتورهای ارسال نشده</span></a>
                                        </li>
                                        <li>
                                            <a className="btn btn-danger" onClick={e => this.sendEnqueue(this.state.ids)}><em class="icon ni ni-arrow-up"></em><span>ارسال گروهی</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/invoice/upload/" className="btn btn-white btn-outline-light"><em className="icon ni ni-download-cloud"></em><span>ورود اکسل اطلاعات</span></NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/invoice/uploadexceltax/" className="btn btn-white btn-outline-light"><em className="icon ni ni-download-cloud"></em><span>ورود اکسل مغایرت گیری</span></NavLink>
                                        </li>
                                        <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a href="#" className="dropdown-toggle btn btn-primary" data-bs-toggle="dropdown" aria-expanded="true"><em className="icon ni ni-plus"></em><span>ایجاد صورت حساب</span></a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><NavLink to="/invoice/new1/"><span>فروش</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new2/"><span>فروش ارزی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new3/"><span>طلا و جواهر و پلاتین</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new4/"><span>پیمانکاری</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new5/"><span>قبوض خدماتی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new6/"><span>بلیت هواپیما</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new7/"><span>صادرات</span></NavLink></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر هیچ صورتحساب فروشی برای مودی شما ثبت نشده است</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">
                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>

                                            <div id="accordion" class="accordion" style={{ width: '100%' }}>
                                                <div class="accordion-item">
                                                    <a href="#" class="accordion-head" data-bs-toggle="collapse" data-bs-target="#accordion-item-1">
                                                        <h6 class="title">جستجوی پیشرفته</h6>

                                                    </a>
                                                    <div class="accordion-body collapse" id="accordion-item-1" data-bs-parent="#accordion">
                                                        <div class="accordion-inner">
                                                            <div className=""></div>
                                                            <div className="row g-gs">
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">انتخاب مشتری</label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync

                                                                                defaultValue={this.state.filters.comId > 0 ? [{ value: this.state.filters.comId, label: this.state.filters.coTitle }] : null}
                                                                                isMulti={false}
                                                                                placeholder="انتخاب مشتری"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.loadPersonsOptions}
                                                                                onChange={e => this.state.filters.comId = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="col-lg-2">
                                                                    <div className="form-group">
                                                                        <label className="form-label">تاریخ شروع</label>
                                                                        <div className="form-control-wrap">
                                                                            <DatePicker

                                                                                value={this.state.filters.startDateM}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "34px",
                                                                                    fontSize: "14px",
                                                                                    padding: "3px 10px",


                                                                                }}

                                                                                onChange={e => this.setStartDate(e)}
                                                                                calendar={persian}
                                                                                locale={persian_fa} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2">
                                                                    <div className="form-group">
                                                                        <label className="form-label">تاریخ پایان</label>
                                                                        <div className="form-control-wrap">
                                                                            <DatePicker

                                                                                value={this.state.filters.endDateM}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "34px",
                                                                                    fontSize: "14px",
                                                                                    padding: "3px 10px",


                                                                                }}

                                                                                onChange={e => this.setEndDate(e)}
                                                                                calendar={persian}
                                                                                locale={persian_fa} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نوع صورت حساب</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" type="text" defaultValue={this.state.filters.inty} onChange={e => this.setinty(parseInt(e.target.value))}>
                                                                                <option value="0">انتخاب نوع صورت حساب</option>
                                                                                <option value="1">اول</option>
                                                                                <option value="2">دوم</option>
                                                                                <option value="3">سوم</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">شماره منحصر به فرد مالیاتی</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" type="text" defaultValue={this.state.filters.taxId} onChange={e => this.state.filters.taxId = e.target.value} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">سریال فاکتور</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" type="text" defaultValue={this.state.filters.serial} onChange={e => this.state.filters.serial = parseInt(e.target.value)} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">وضعیت صورت حساب</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" type="text" defaultValue={this.state.filters.statusTax} onChange={e => this.setStatusTax(parseInt(e.target.value))}>
                                                                                <option value="0">انتخاب وضعیت صورت حساب</option>
                                                                                <option value="1">تایید شده</option>
                                                                                <option value="2">باطل شده</option>
                                                                                <option value="3">عدم نیاز به واکنش</option>
                                                                                <option value="4">رد شده</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نوع فاکتور</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" type="text" defaultValue={this.state.filters.type} onChange={e => this.setTypeRec(parseInt(e.target.value))}>
                                                                                <option value="0">انتخاب وضعیت</option>
                                                                                <option value="1">فروش</option>
                                                                                <option value="3">طلاجواهر و پلاتین</option>
                                                                                <option value="2">فروش ارز</option>
                                                                                <option value="4">پیمانکاری</option>
                                                                                <option value="5">قبوض خدماتی</option>
                                                                                <option value="6">بلیط هواپیما</option>
                                                                                <option value="7">صادرات</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نوع فصل</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" type="text" defaultValue={this.state.filters.fasl} onChange={e => this.setTypeFasl(parseInt(e.target.value))}>
                                                                                <option value="0">انتخاب وضعیت</option>
                                                                                <option value="1">بهار</option>
                                                                                <option value="2">تابستان</option>
                                                                                <option value="3">پاییز</option>
                                                                                <option value="4">زمستان</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">برای فیلتر کردن دیکه جستجو را بزنید</label>
                                                                        <div className="form-control-wrap">
                                                                            <div className="btn-wrap">
                                                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-success hand"><em class="icon ni ni-search"></em> جستجوی اطلاعات </button></span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label">بازیابی اطلاعات</label>
                                                                        <div className="form-control-wrap">
                                                                            <div className="btn-wrap">
                                                                                <span className="d-none d-md-block">
                                                                                    <Button onClick={e => this.recoveryData(e)} className="btn-dim" outline color="info"><em class="icon ni ni-search"></em> بازیابی اطلاعات  </Button>

                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>




                                        </form>
                                    </div>
                                </div>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head" style={{ backgroundColor: "#16498a" }}>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">انتخاب</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">ردیف</span></div>
                                            <div className="nk-tb-col" onClick={e => this.Sort("Inp")}><span className="sub-text text-center text-white">الگو<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col" onClick={e => this.Sort("Ins")}><span className="sub-text text-center text-white">موضوع<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col" onClick={e => this.Sort("Inty")}><span className="sub-text text-center text-white">نوع<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col tb-col-sm" onClick={e => this.Sort("Inno")}><span className="sub-text text-center text-white">سریال<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col tb-col-lg" onClick={e => this.Sort("TaxId")}><span className="sub-text text-center text-white">شماره منحصربفرد مالیاتی<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col tb-col-md" onClick={e => this.Sort("IrtaxId")}><span className="sub-text text-center text-white">شماره مالیاتی مرجع<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col tb-col-md" onClick={e => this.Sort("IndatimPersian")}><span className="sub-text text-center text-white">تاریخ صدور صورت حساب<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col tb-col-md" onClick={e => this.Sort("IndatimPersian")}><span className="sub-text text-center text-white">تاریخ ثبت در سامانه<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col text-end" onClick={e => this.Sort("CustomerName")}><span className="sub-text text-center text-white">طرف حساب<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col text-end" onClick={e => this.Sort("Tbill")}><span className="sub-text text-center text-white">مبلغ کل<em class="icon ni ni-sort"></em></span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">نحوه تسویه</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">وضعیت</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">وضعیت در سامانه</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-white">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <div class="custom-control custom-control-sm custom-checkbox checked">
                                                        <input type="checkbox" class="custom-control-input" onChange={e => this.setChecked(e, record.id)} id={"customCheck" + this.genRowNumber(index)} />
                                                        <label class="custom-control-label" for={"customCheck" + this.genRowNumber(index)}></label>
                                                    </div>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.inpString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.insString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.intyString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="sub-text text-center tb-lead">{record.inno}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center tb-lead">{record.taxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center tb-lead">{record.irtaxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.indatimPersian}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.sendTax}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.customerName}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{this.money(record.tbill)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    {record.setm === 1 && <span className="sub-text text-center tb-lead">نقدی</span>}
                                                    {record.setm === 2 && <span className="sub-text text-center tb-lead">نسیه</span>}
                                                    {record.setm === 3 && <span className="sub-text text-center tb-lead">نقد/نسیه</span>}
                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">
                                                    {record.status === 1 && <span class="badge tb-status text-info">{record.statusString}</span>}
                                                    {record.status === 2 && <span class="badge tb-status text-warning">{record.statusString}</span>}
                                                    {record.status === 3 && <span class="badge tb-status text-danger">{record.statusString}</span>}
                                                    {record.status === 4 && <span class="badge tb-status text-success">{record.statusString}</span>}
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{this.money(record.statusTax)}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        {this.getToolBars(record)}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}